import { render, staticRenderFns } from "./OnboardingCollaborator.vue?vue&type=template&id=6f372b45&scoped=true"
import script from "./OnboardingCollaborator.vue?vue&type=script&lang=js"
export * from "./OnboardingCollaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f372b45",
  null
  
)

export default component.exports